import { Fragment } from 'react';

export function Renewals() {
  return (
    <Fragment>
      All subscriptions are automatically renewed on a recurring basis, which may include monthly, bimonthly, quarterly, semi-annually, annually, or biannually bases, depending on the User’s choice at the time of initial payment and any subsequent User requests to change the billing period. The date of renewal is identified in the Subscription Portal on our website.
      <br /><br />
      If there are changes regarding accessible content or the price of a subscription plan, we will notify Users at least fourteen (14) days in advance, unless unforeseen third-party decisions make such notification impossible. Users whose renewal date falls between the date of announcement and the date of implementation reserve the right to cancel or modify their subscription for the next billing cycle, even after payment, without penalty.
    </Fragment>
  );
}


export default Renewals;
